var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevicesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 96,
    height: 96,
    rx: 8,
    fill: "#E3EEF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.44 43.62H35.56C31.4 43.62 28 40.2201 28 36.0601C28 31.9001 31.4 28.5 35.56 28.5H39.34C42.46 28.5 45 31.06 45 34.16V39.28V58.7C45 60.78 43.3 62.48 41.22 62.48C39.14 62.48 37.44 60.78 37.44 58.7V43.62Z",
    stroke: "#202224",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5599 37.9401C34.5199 37.9401 33.6799 37.1002 33.6799 36.0602C33.6799 35.0202 34.5199 34.1802 35.5599 34.1802",
    stroke: "#202224",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.56 43.62H60.44C64.6 43.62 68 40.2201 68 36.0601C68 31.9001 64.6 28.5 60.44 28.5H56.66C53.54 28.5 51 31.06 51 34.16V39.28V58.7C51 60.78 52.7 62.48 54.78 62.48C56.86 62.48 58.56 60.78 58.56 58.7V43.62Z",
    stroke: "#202224",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4399 37.9401C61.4799 37.9401 62.3199 37.1002 62.3199 36.0602C62.3199 35.0202 61.4799 34.1802 60.4399 34.1802",
    stroke: "#202224",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41 68.5V62.5",
    stroke: "#202224",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55 68.5V62.5",
    stroke: "#202224",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicesIcon);
export default __webpack_public_path__ + "static/media/devicesIcon.76cd7d6afcfc9e492a05bf40d43b927d.svg";
export { ForwardRef as ReactComponent };